import { makeStyles } from 'transfix-ui/core/styles'

export const useReeferEquipmentFormSectionStyles = makeStyles(() => ({
  radioContainer: {
    '& > div': {
      display: 'flex',
    },
    '& label': {
      flex: '0 0 50%',
    },
  },
}))
